module.exports = __webpack_public_path__ + "static/media/membership_card.e9fb2a84.svg";